import get from 'lodash.get';

const getPartnerData = (rootState) => get(rootState, 'user.partnerData', null);

export default getPartnerData;
